import React from "react";
import { Boxes, BadgePercent, ShieldCheck, HeadphonesIcon } from "lucide-react";

const ADVANTAGES = [
  {
    icon: Boxes,
    title: "Massive In-Stock Variety",
    body: "A huge, diverse catalog curated for immediate project delivery — from broadloom rolls to bespoke wallpapers.",
    metric: "10,000+ SKUs",
  },
  {
    icon: BadgePercent,
    title: "Wholesale Pricing Advantage",
    body: "Cutting out middlemen to pass direct container-load savings on to architects, contractors and retail buyers.",
    metric: "Direct from origin",
  },
  {
    icon: ShieldCheck,
    title: "Uncompromising Quality",
    body: "Handpicked global imports built to withstand heavy foot traffic, with 5-year to lifetime warranties.",
    metric: "LEED & GBC ready",
  },
  {
    icon: HeadphonesIcon,
    title: "Elite Customer Care",
    body: "Dedicated wholesale desk for large-scale architectural, hospitality and contracting projects — end to end.",
    metric: "4 decades of trust",
  },
];

export default function Advantages() {
  return (
    <section id="advantages" className="relative py-24 lg:py-32 bg-slate-950 overflow-hidden" data-testid="advantages-section">
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-grain opacity-30" />
        <div className="absolute -top-32 -right-32 h-[420px] w-[420px] rounded-full bg-amber-700/20 blur-3xl" />
        <div className="absolute -bottom-32 -left-32 h-[420px] w-[420px] rounded-full bg-amber-700/10 blur-3xl" />
      </div>

      <div className="relative mx-auto max-w-7xl px-5 lg:px-10">
        <div className="max-w-3xl">
          <p className="eyebrow mb-4 !text-amber-500">The Direct Importer Advantage</p>
          <h2 className="font-display text-white text-4xl md:text-5xl lg:text-6xl font-medium tracking-tight leading-[1.05]">
            Why architects & contractors keep coming back.
          </h2>
          <p className="mt-5 text-white/65 max-w-xl">
            We are not a reseller. We import containers directly from global mills and pass those margins to you — with the showroom & service backbone of a 40-year-old Bengaluru institution.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {ADVANTAGES.map((a, i) => {
            const Icon = a.icon;
            return (
              <article
                key={a.title}
                className="group relative bg-white/[0.025] border border-white/10 hover:border-amber-700/60 hover:bg-white/[0.04] p-7 transition-all duration-500"
                style={{ animationDelay: `${i * 80}ms` }}
                data-testid={`advantage-card-${i}`}
              >
                <div className="flex items-center justify-between mb-8">
                  <span className="inline-flex h-12 w-12 items-center justify-center bg-amber-700/15 border border-amber-700/40 text-amber-400">
                    <Icon className="h-5 w-5" />
                  </span>
                  <span className="font-display text-3xl text-white/30 group-hover:text-amber-500/60 transition-colors">0{i + 1}</span>
                </div>
                <h3 className="font-display text-2xl text-white leading-tight">{a.title}</h3>
                <p className="mt-3 text-sm text-white/65 leading-relaxed">{a.body}</p>
                <div className="mt-6 pt-5 border-t border-white/10 text-[11px] tracking-[0.24em] uppercase text-amber-400">
                  {a.metric}
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
